module.exports = __webpack_public_path__ + "static/media/success.cf1edefd.png";